import React, { Component } from 'react';
import { connect } from 'react-redux';
import StdRiskRow from './StdRiskRow';
import './PerformanceTable.css';
import i18n from '../../../i18n';


class StdRiskTable extends Component {

  // create the rows
  renderRows() {
    const {
      data
    } = this.props;

    return data.map((fund) => {
      return (
        <StdRiskRow key={fund.externalID} fund={fund} />
      );
    });
  }

  // create the header
  renderHeader() {
    const asOfDate = new Date(this.props.data[0].stdRisk[0]?.asOfDate).toLocaleDateString();
    const commonStartDate = new Date(this.props.data[0].stdRisk[0]?.commonPeriodNAVStart).toLocaleDateString();
    const commonEndDate = new Date(this.props.data[0].stdRisk[0]?.commonPeriodNAVEnd).toLocaleDateString();
    return (
      <thead>
        <tr>
          <th colSpan='3' scope='colgroup' className='textLeft' >VOLATILITY (STANDARD DEVIATION)<br />{i18n.t('as of')} {asOfDate}</th>
          <th colSpan='6' scope='colgroup' className='borderleft borderbottom textCenter'>{i18n.t('Average Annual Volatility')}</th>
        </tr>
        <tr>
          <th scope='col' className='textLeft'>{i18n.t('Ticker')}</th>
          <th scope='col' className='textLeft'>{i18n.t('Fund')}</th>
          <th scope='col' className='textCenter'>{i18n.t('Inception')}<br /> {i18n.t('Date')}</th>
          <th scope='col' className='borderleft textCenter'>{i18n.t('Common Period')}<br /> {commonStartDate} - {commonEndDate}  </th>
          <th scope='col' className='textCenter'>{i18n.t('1-Year')}</th>
          <th scope='col' className='textCenter'>{i18n.t('3-Year')}</th>
          <th scope='col' className='textCenter'>{i18n.t('5-Year')}</th>
          <th scope='col' className='textCenter'>{i18n.t('10-Year')}</th>
          <th scope='col' className='textCenter'>{i18n.t('Since')} <br />{i18n.t('Inception')}</th>

        </tr>
      </thead>
    );
  }

  render() {
    if (this.props.data && this.props.data[0].stdRisk) {
      return (
        <div>
          {/* <div className={s.heading}>{i18n.t('Volatility (Standard Deviation)')}</div> */}
          <div className='table-responsive'>
            <table className='table tableFC'>
              {this.renderHeader()}
              <tbody>{this.renderRows()}</tbody>
            </table>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}

function mapStateToProps(state) {
  return {
    data: state.fundData.data,
  };
}
export default connect(mapStateToProps, {})(StdRiskTable);
